<ruckit-dropdown #marketsDropdown
  [config]="marketsConfig"
  [selectedItems]="selectedOptions"
  (onSelect)="selectTags($event)">
</ruckit-dropdown>
